<template>
    <SmartLinkItemComponent custom-tag="div" class="coming-soon-page" v-if="page" :id="page.system.id" :component="!page.system.workflow">
        <SmartLinkStandaloneElement custom-tag="div" class="header" :codename="contentTypes.site_redirect_page.elements.logo.codename">
            <NuxtImg v-if="page?.elements?.logo?.value?.length > 0" :src="page.elements.logo.value[0].url" class="img-fluid" />
        </SmartLinkStandaloneElement>
        <SmartLinkStandaloneElement custom-tag="div" class="text"
            :codename="contentTypes.site_redirect_page.elements.redirect_page_text.codename">
            <RichText :value="page.elements.redirectPageText.value" />
        </SmartLinkStandaloneElement>
    </SmartLinkItemComponent>
</template>

<script lang="ts" setup>
    import { contentTypes } from '~/models';
    import type { SiteRedirectPageModel } from '~/models';
    const pageStore = usePageStore();
    const siteStore = useSiteStore();

    const page = pageStore.page as SiteRedirectPageModel;

    const showHeaderAndFooter = useState('showHeaderAndFooter');

    showHeaderAndFooter.value = false;
</script>
